var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_6238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01104 18.011V6.98604C5.01104 6.43604 5.21104 5.96904 5.61104 5.58604C5.7986 5.40053 6.02117 5.25416 6.26581 5.15545C6.51044 5.05674 6.77226 5.00765 7.03604 5.01104H18.011C18.561 5.01104 19.031 5.20704 19.424 5.59804C19.815 5.99004 20.011 6.46104 20.011 7.01104V15.011L15.011 20.011H7.01104C6.46104 20.011 5.99104 19.815 5.59804 19.424C5.40886 19.2411 5.25917 19.0214 5.15821 18.7783C5.05725 18.5353 5.00716 18.2742 5.01104 18.011ZM0.0360438 4.26104C-0.0639562 3.71104 0.0440438 3.21504 0.361044 2.77304C0.678044 2.33204 1.11104 2.06104 1.66104 1.96104L12.511 0.0360438C13.061 -0.0639562 13.557 0.0440438 13.999 0.361044C14.44 0.678044 14.711 1.11104 14.811 1.66104L15.061 3.01104H13.011L12.836 2.01104L2.01104 3.93604L3.01104 9.58604V16.561C2.74312 16.4102 2.50897 16.206 2.32304 15.961C2.13236 15.7129 2.0078 15.4205 1.96104 15.111L0.0360438 4.26104ZM7.01104 7.01104V18.011H14.011L18.011 14.011V7.01104H7.01104ZM11.511 16.511H13.511V13.511H16.511V11.511H13.511V8.51104H11.511V11.511H8.51104V13.511H11.511V16.511Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_6238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCategory);
export default __webpack_public_path__ + "static/media/add_category.7a8a0ee378812aa44493721b32e8b056.svg";
export { ForwardRef as ReactComponent };